<template>
  <el-dialog
    title="新增支付方式"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :width="dialogWidth"
    @close="handleClose"
  >
    <div class="payment-form">
      <div class="form-item">
        <span class="form-label">银行名称:</span>
        <el-select
          v-model="accountForm.bankId"
          placeholder="请选择银行"
          class="filter-item"
          clearable
          @change="handleChange"
        >
          <el-option
            v-for="item in bankList"
            :key="item.id"
            :label="item.bankName"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="form-item">
        <span class="form-label">支行名称:</span>
        <el-input v-model="accountForm.branchName" placeholder="请输入支行名称" />
      </div>
      <div class="form-item">
        <span class="form-label">银行卡号:</span>
        <el-input v-model="accountForm.bankAccount" placeholder="请输入银行卡号" />
      </div>
      <div class="form-item">
        <span class="form-label">开户名:</span>
        <el-input v-model="accountForm.accountName" placeholder="请输入开户名" />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="btnLoading">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getBankListQuery } from "@/api/leve";
export default {
  name: "PaymentMethodAdd",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bankList: [],
      accountForm: {
        bankId: "",
        bankName: "", // 银行名称
        branchName: "", // 支行名称
        bankAccount: "", // 银行卡号
        accountName: "", // 开户名
        bankLogo: "",
      },
      btnLoading: false,
    };
  },
  computed: {
    dialogWidth() {
      return window.innerWidth <= 768 ? '90%' : '60%';
    }
  },
  created() {
    this.onWithdrawAccount();
  },
  methods: {
    //  获取银行列表
    async onWithdrawAccount() {
      getBankListQuery().then((res) => {
        this.bankList = res.data;
        console.log("获取银行列表", this.bankList);
      });
    },
    // 选择银行列表
    handleChange(item) {
      const bank = this.bankList.find((val) => val.id === item);
      this.accountForm.bankLogo = bank?.bankLogo;
      this.accountForm.bankName = bank?.bankName;
      console.log("选择银行列表", item, this.accountForm);
    },
    saveData() {
      // 验证表单数据
      if (!this.accountForm.bankId) {
        this.$message.error('请选择银行名称');
        return;
      }
      if (!this.accountForm.branchName) {
        this.$message.error('请输入支行名称');
        return;
      }
      if (!this.accountForm.bankAccount) {
        this.$message.error('请输入银行卡号');
        return;
      }
      if (!this.accountForm.accountName) {
        this.$message.error('请输入开户名');
        return;
      }
      
      this.btnLoading = true;
      // 触发保存事件，将表单数据传递给父组件
      this.$emit("save", { ...this.accountForm });
    },
    handleClose() {
      // 当弹窗关闭时，重置表单
      this.resetForm();
      // 触发关闭事件
      this.$emit("close");
    },
    resetForm() {
      // 重置表单数据
      this.accountForm = {
        bankId: "",
        bankName: "",
        branchName: "",
        bankAccount: "",
        accountName: "",
        bankLogo: "",
      };
      this.btnLoading = false;
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.payment-form {
  padding: 0 20px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  min-height: 40px;
}

.form-label {
  width: 120px;
  text-align: right;
  margin-right: 15px;
  font-weight: bold;
  color: #333;
  font-size: 15px;
  flex-shrink: 0;
}

.form-item ::v-deep .el-input,
.form-item ::v-deep .el-select {
  flex: 1;
  max-width: 300px;
}

/* // 响应式样式 */
@media screen and (max-width: 768px) {
  .payment-form {
    padding: 0 10px;
  }
  
  .form-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  
  .form-label {
    width: auto;
    text-align: left;
    margin-right: 0;
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .form-item ::v-deep .el-input,
  .form-item ::v-deep .el-select {
    width: 100%;
    max-width: none;
  }
}

@media screen and (max-width: 480px) {
  .payment-form {
    padding: 0 5px;
  }
  
  .form-label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .form-item {
    margin-bottom: 12px;
  }
  
  .form-item ::v-deep .el-input__inner,
  .form-item ::v-deep .el-select .el-input__inner {
    font-size: 14px;
  }
}
</style>ß